module.exports = __webpack_public_path__ + "media/images/facebook-button-76273e9e21adbfac2c911723431036e9.svg";